var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('rechts-sammlung')],1),_c('div',[_c('mustervorlagen')],1),_c('div',{staticClass:"mb-5"},[_c('terminlisten')],1),_c('div',{staticClass:"pt-3"},[_c('rechenschaftsberichte')],1),_c('div',{staticClass:"pt-3"},[_c('protokolle')],1),_c('div',[_c('finanzausgleich')],1),_c('div',{staticClass:"pt-3 mt-3"},[_c('archiv')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }